import { isEmpty } from "lodash";
import { AccessRight } from "../constant/accessRights";

export const includesRight = (requiredRight: AccessRight, userRight: AccessRight): boolean => {
  switch (requiredRight) {
    case AccessRight.NONE:
      return true;
    case AccessRight.VIEW:
      return (
        userRight === AccessRight.VIEW ||
        userRight === AccessRight.FACILITATOR ||
        userRight === AccessRight.EDIT ||
        userRight === AccessRight.ADMIN
      );
    case AccessRight.FACILITATOR:
      return userRight === AccessRight.FACILITATOR || userRight === AccessRight.EDIT || userRight === AccessRight.ADMIN;
    case AccessRight.EDIT:
      return userRight === AccessRight.EDIT || userRight === AccessRight.ADMIN;
    case AccessRight.ADMIN:
      return userRight === AccessRight.ADMIN;
    default:
      return false;
  }
};

export const allowSaveAs = (
  loggedIn: boolean,
  hasEditRights: boolean,
  courseId: string | undefined,
  courseAllowsSaveAs: boolean | undefined | null
): boolean => {
  // Check we have a logged in user
  if (!loggedIn) {
    return false;
  }
  // Anyone with a direct (non-course) access to a map
  // can do a save as
  if (isEmpty(courseId)) {
    return true;
  }
  // Check if the course allows SaveAs, however, if the user has edit access,
  // we can ignore this setting (because the map owner has overriden this by giving edit access to the user)
  return Boolean(courseAllowsSaveAs) || hasEditRights;
};
